import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../images/services-usa/construction-software/why-choose-back.webp";

function Whychooseconstruction() {
  return (
    <section
      className="whychoose_construction text_white p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>
              Why Choose Tekrevol as{" "}
              <span>Your Construction Software Development </span>
              Company?
            </h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <p>
              Tekrevol is more than a reliable construction software development
              company. We are a team of engineers, developers, and problem
              solvers proficient in cutting-edge technologies.
            </p>
            <p>
              We understand your unique business challenges and develop
              fine-tuned solutions that help you do stuff better.
            </p>
          </Col>
        </Row>
        <Row className="mt-3 mt-md-4">
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4 mb-xl-0">
            <div className="why-choose-box">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38"
                  height="38"
                  fill="none"
                  viewBox="0 0 38 38"
                >
                  <mask
                    id="mask0_5453_3915"
                    width="38"
                    height="38"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                    style={{ maskType: "luminance" }}
                  >
                    <path
                      fill="#fff"
                      stroke="#fff"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19.001 36.063a16.7 16.7 0 0 0 6.54-1.329 17 17 0 0 0 5.54-3.797 17.5 17.5 0 0 0 3.707-5.676c.859-2.123 1.3-4.4 1.297-6.698a17.8 17.8 0 0 0-1.297-6.7 17.5 17.5 0 0 0-3.707-5.675 17 17 0 0 0-5.54-3.797A16.7 16.7 0 0 0 19 1.063a16.7 16.7 0 0 0-6.539 1.328 17 17 0 0 0-5.54 3.797 17.5 17.5 0 0 0-3.707 5.676c-.86 2.124-1.3 4.4-1.297 6.698a17.8 17.8 0 0 0 1.297 6.7 17.5 17.5 0 0 0 3.707 5.675 17 17 0 0 0 5.54 3.797 16.7 16.7 0 0 0 6.54 1.328Z"
                    ></path>
                    <path
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m12.168 18.563 5.125 5.25 10.25-10.5"
                    ></path>
                  </mask>
                  <g mask="url(#mask0_5453_3915)">
                    <path fill="#F47A1F" d="M-1.498-2.437h41v42h-41z"></path>
                  </g>
                </svg>
              </div>
              <h5>Business-Centric Solutions</h5>
              <p>
                We create software solutions focused on business value so you
                can make the most of your processes and achieve your goals
                effectively.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4 mb-xl-0">
            <div className="why-choose-box">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38"
                  height="38"
                  fill="none"
                  viewBox="0 0 38 38"
                >
                  <mask
                    id="mask0_5453_3915"
                    width="38"
                    height="38"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                    style={{ maskType: "luminance" }}
                  >
                    <path
                      fill="#fff"
                      stroke="#fff"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19.001 36.063a16.7 16.7 0 0 0 6.54-1.329 17 17 0 0 0 5.54-3.797 17.5 17.5 0 0 0 3.707-5.676c.859-2.123 1.3-4.4 1.297-6.698a17.8 17.8 0 0 0-1.297-6.7 17.5 17.5 0 0 0-3.707-5.675 17 17 0 0 0-5.54-3.797A16.7 16.7 0 0 0 19 1.063a16.7 16.7 0 0 0-6.539 1.328 17 17 0 0 0-5.54 3.797 17.5 17.5 0 0 0-3.707 5.676c-.86 2.124-1.3 4.4-1.297 6.698a17.8 17.8 0 0 0 1.297 6.7 17.5 17.5 0 0 0 3.707 5.675 17 17 0 0 0 5.54 3.797 16.7 16.7 0 0 0 6.54 1.328Z"
                    ></path>
                    <path
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m12.168 18.563 5.125 5.25 10.25-10.5"
                    ></path>
                  </mask>
                  <g mask="url(#mask0_5453_3915)">
                    <path fill="#F47A1F" d="M-1.498-2.437h41v42h-41z"></path>
                  </g>
                </svg>
              </div>
              <h5>Proven Industry Experience</h5>
              <p>
                With 6+ years of experience developing custom construction
                software solutions, we understand your challenges and how to
                overcome them.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3} className="mb-4 mb-md-0">
            <div className="why-choose-box">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38"
                  height="38"
                  fill="none"
                  viewBox="0 0 38 38"
                >
                  <mask
                    id="mask0_5453_3915"
                    width="38"
                    height="38"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                    style={{ maskType: "luminance" }}
                  >
                    <path
                      fill="#fff"
                      stroke="#fff"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19.001 36.063a16.7 16.7 0 0 0 6.54-1.329 17 17 0 0 0 5.54-3.797 17.5 17.5 0 0 0 3.707-5.676c.859-2.123 1.3-4.4 1.297-6.698a17.8 17.8 0 0 0-1.297-6.7 17.5 17.5 0 0 0-3.707-5.675 17 17 0 0 0-5.54-3.797A16.7 16.7 0 0 0 19 1.063a16.7 16.7 0 0 0-6.539 1.328 17 17 0 0 0-5.54 3.797 17.5 17.5 0 0 0-3.707 5.676c-.86 2.124-1.3 4.4-1.297 6.698a17.8 17.8 0 0 0 1.297 6.7 17.5 17.5 0 0 0 3.707 5.675 17 17 0 0 0 5.54 3.797 16.7 16.7 0 0 0 6.54 1.328Z"
                    ></path>
                    <path
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m12.168 18.563 5.125 5.25 10.25-10.5"
                    ></path>
                  </mask>
                  <g mask="url(#mask0_5453_3915)">
                    <path fill="#F47A1F" d="M-1.498-2.437h41v42h-41z"></path>
                  </g>
                </svg>
              </div>
              <h5>End-to-End Software Development</h5>
              <p>
                Tekrevol is a one-stop solution for all your software needs.
                From ideation to delivery, we handle every aspect and scale of
                software development.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={3} xxl={3}>
            <div className="why-choose-box">
              <div className="icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="38"
                  height="38"
                  fill="none"
                  viewBox="0 0 38 38"
                >
                  <mask
                    id="mask0_5453_3915"
                    width="38"
                    height="38"
                    x="0"
                    y="0"
                    maskUnits="userSpaceOnUse"
                    style={{ maskType: "luminance" }}
                  >
                    <path
                      fill="#fff"
                      stroke="#fff"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M19.001 36.063a16.7 16.7 0 0 0 6.54-1.329 17 17 0 0 0 5.54-3.797 17.5 17.5 0 0 0 3.707-5.676c.859-2.123 1.3-4.4 1.297-6.698a17.8 17.8 0 0 0-1.297-6.7 17.5 17.5 0 0 0-3.707-5.675 17 17 0 0 0-5.54-3.797A16.7 16.7 0 0 0 19 1.063a16.7 16.7 0 0 0-6.539 1.328 17 17 0 0 0-5.54 3.797 17.5 17.5 0 0 0-3.707 5.676c-.86 2.124-1.3 4.4-1.297 6.698a17.8 17.8 0 0 0 1.297 6.7 17.5 17.5 0 0 0 3.707 5.675 17 17 0 0 0 5.54 3.797 16.7 16.7 0 0 0 6.54 1.328Z"
                    ></path>
                    <path
                      stroke="#000"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="m12.168 18.563 5.125 5.25 10.25-10.5"
                    ></path>
                  </mask>
                  <g mask="url(#mask0_5453_3915)">
                    <path fill="#F47A1F" d="M-1.498-2.437h41v42h-41z"></path>
                  </g>
                </svg>
              </div>
              <h5>
                Latest Technology
                <br className="d-none d-lg-block" /> Stack
              </h5>
              <p>
                From Generative AI to AR/VR, our team stays at the top of the
                latest technologies to ensure you get an up-to-date and
                future-ready solution.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whychooseconstruction;
